export default "__VITE_ASSET__u8egkvGY7JAETGkFYZzsbg__"